import { render, staticRenderFns } from "./c_banner.vue?vue&type=template&id=b21cd35c&scoped=true&"
import script from "./c_banner.vue?vue&type=script&lang=js&"
export * from "./c_banner.vue?vue&type=script&lang=js&"
import style0 from "./c_banner.vue?vue&type=style&index=0&id=b21cd35c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21cd35c",
  null
  
)

export default component.exports